import React from "react";
import Table from 'react-bootstrap/Table'
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';


export default function NotificationsGridSingle(props) {

  const history = useHistory();
  const { t } = useTranslation();

  const selectRequirement = (req_id) => {
   history.push('/links/' + req_id);
  }

  return (
      <Table  bordered hover className="custom-responsive double-rowed">
        <thead>
          <tr>
            <th>{t('Date')}</th>
            <th>{t('Document type')}</th>
            <th>{t('Standard ID')}</th>
            <th>{t('Number')}</th>
          </tr>
        </thead>
        {
          0 < props.notifications.length ?
          props.notifications?.sort((a, b) => (new Date(a.updated_at).valueOf  > new Date(b.updated_at).valueOf ) ? -1 : 1).map(function(value, index){
            return <tbody
                    className="pointer"
                    key={ index + 'data' }
                    onClick={() => selectRequirement(value.data.req?.id)}>
                    <tr key={ index + 'data' }>
                        <td>{value.updated_at}</td>
                        <td>{value.data.req?.doc_type_text}</td>
                        <td>{value.data.req?.standard_number}</td>
                        <td>{value.data.req?.section}</td>
                    </tr>
                    <tr>
                       <td colSpan="4">{value.data.message}&nbsp;
                       <span
                        className="pointer link-color hover-underline">{t('Click here to view')}.</span>
                       </td>
                     </tr>
                    </tbody>;
          })
          : <tbody><tr><td colSpan="4">{t('No notifications')}</td></tr></tbody>
        }
      </Table>
  );
}
